import s from './LocationList.module.scss';
import LocationCard from '../../../components/LocationCard/LocationCard';

const LocationList = () => {
    return (

        <div className={"row mt-5"}>
            <div className={"col-12"}>
                <div className={"row"}>
                    <div className={"col-12"}>
                        <div className={s.titleContainer}>
                            <span>Tours Across Australia</span>
                            <h2>オーストラリア全土のツアー</h2>
                        </div>
                    </div>
                </div>

                <div className={"row mt-2"}>
                    <div className={"col-12"}>
                        <LocationCard/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LocationList;
